import React, { useEffect, useState } from 'react';
import defaultImg from '../../../../assets/images/default-organization.png';
import { getOrganization } from '../../../api/organizationsAPI';
import { CLOUDINARY_DIR } from '../../utils/contants';
import PurpleLoadingSpinner from '../../../../assets/images/loading-spinner-purple.svg';
/**
 * A sponsorship partner icon + text, found under organization profile's overview tab
 * @param className
 * @param orgData the organization data
 * @constructor
 */
export const SponsorshipPartner = ({ orgData }) => {
	const [imageSrc, setImageSrc] = useState(null);
	const [isImgFetching, setImgFetching] = useState(false);

	/**
	 * Redirects to sponsorship partner
	 */
	const redirectToSponsorshipPartner = () => {
		window.open(orgData.id, '_blank');
	};

	useEffect(() => {
		let isMounted = true; // Add a flag to check if the component is mounted

		async function getMissingLogo() {
			setImgFetching(true);
			const { data } = await getOrganization(orgData.id);

			let logoFromAssetUrl =
				data?.assets && data?.assets?.length > 0 && data?.assets[0].url;
			let logoFromAssetPath =
				data?.assets &&
				data?.assets?.length > 0 &&
				data?.assets[0].path;

			if (isMounted) {
				// Only update the state if the component is still mounted
				if (logoFromAssetUrl) {
					setImageSrc(logoFromAssetUrl);
				} else if (logoFromAssetPath) {
					setImageSrc(CLOUDINARY_DIR + logoFromAssetPath);
				} else {
					setImageSrc(defaultImg);
				}
			}
			setImgFetching(false);
		}

		if (orgData.logo?.path) {
			setImageSrc(
				`https://res.cloudinary.com/sponsor-circle/image/upload/${orgData.logo?.path}`
			);
		} else if (orgData.logo?.url) {
			setImageSrc(orgData.logo?.url);
		} else if (orgData.id !== undefined) {
			getMissingLogo();
		}

		return () => {
			isMounted = false; // Set the flag to false when the component unmounts
		};
	}, [orgData]);

	return (
		<a
			className={'sponsorship-partner-inner-container'}
			onClick={redirectToSponsorshipPartner}
		>
			<div className="org-logo-container">
				<img
					src={isImgFetching ? PurpleLoadingSpinner : imageSrc}
					alt={`${orgData?.legal_name} Logo`}
					className="org-logo"
				/>
			</div>
			<p className="org-legal-name">{orgData.legal_name}</p>
		</a>
	);
};
